





































import { Vue, Component } from "@/shared/vuepack";
import { useBalanceTransferStore, goToStep } from "@/employee/store/balanceTransfer";
import Button from "@/shared/components/ui/Button.vue";
import FormDownload from "@/employee/components/onboarding/balance-transfer/FormDownload.vue";

@Component({
  components: {
    Button,
    FormDownload
  }
})
export default class TrusteeToTrusteeTransferFormDownload extends Vue {
  balanceTransferStore = useBalanceTransferStore();

  generateForm () {
    return this.balanceTransferStore.generateTrusteeToTrusteeBalanceTransferForm();
  }

  goToNextStep () {
    goToStep("trustee-finish");
  }

  goToPreviousStep () {
    goToStep("trustee-details");
  }
}
